<div class="feedbackComponent" #divcontainer>

  <table class="contentTable">
    <tr>
      <td class="navigationColumn">
        <svg id="navigationFeedbackLeft" class="nav-arrow">
          <path d="M31.122 2.828L29.708 0L0 59.414L29.708 118.828L31.122 116L2.829 59.414L31.122 2.828Z"/>
        </svg>
      </td>
      <td class="contentColumn">
        <div class="feedbackContent">
          <h2 [translate]="'widgets.teamMood.voteFeedback'">Feedback</h2>

          <div>
            <div class="dropdownContent">
              <div class="dropdown">
                <select class="dropdown__select" [(ngModel)]="selectedSprintId" (change)="onSelectedSprintChanged()">
                  <option class="dropdown__item" *ngFor="let sprint of sprints"
                              [value]="sprint.id">
                              {{sprint.name}}
                  </option>
                </select>
                <div class="dropdown__icon">
                  <i class="material-icons">keyboard_arrow_down</i>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="showFeedback; else loadingBlock" class="questionaryContent">
            <div *ngIf="feedback.length > 0">
              <div class="feedbackItem" *ngFor="let f of this.feedback">
                <div class="feedbackLabel">{{f.comment}}</div>
                <div class="feedbackItemFood">
                  <mat-divider></mat-divider>
                  <div class="feedbackLabelDate">{{f.date}}</div>
                  <div class="feedbackAvatarContainer">
                    <img *ngIf="f.person" class="feedbackAvatar" matTooltip="{{f.personName}}" [src]="'data:image/png;base64,'+ f.avatarImage">
                    <mat-icon *ngIf="!f.person" class="feedbackAvatar">person</mat-icon>
                  </div>
                </div>
              </div>
            </div>
            <div class="feedbackItem" *ngIf="feedback.length === 0">
              <div class="feedbackLabel" [translate]="'widgets.teamMood.noCommentYet'">No comment yet!</div>
            </div>
          </div>
          <ng-template #loadingBlock class="questionaryContent" style="margin: auto;">
            <h3  class="loading-cont" [translate]="'widgets.teamMood.dataLoadAnim'">Loading<span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span></h3>
          </ng-template>

        </div>
      </td>
      <td class="navigationColumn">
      </td>
    </tr>
  </table>
</div>
